module.exports = __webpack_public_path__ + "img/edit.bcc524e1.svg";